export class FileUploadType {
    public static ORG_LOGO = 'ORG_LOGO';
    public static MENU_ITEM = 'MENU_ITEM';
    public static DONATION_IMAGE = 'DONATION_IMAGE';
    public static PICKUP_LOCATION = 'PICKUP_LOCATION';
    public static MARKETING_PUSH = 'MARKETING_PUSH';
}
